<div class="main-wrapper">
  <div class="bar-wrapper" [ngStyle]="{'width': percentage + '%'}"></div>
  <div class="text-wrapper">{{ percentage }}% Complete</div>
</div>
